import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "./serviceWorkerRegistration";

// Sentry: client-side error + perf monitoring (no-op when DSN unset)
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV || "production",
    release: process.env.REACT_APP_RELEASE || "doozygo@local",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.05,   // 5% of normal sessions
    replaysOnErrorSampleRate: 1.0,    // 100% of error sessions
    sendDefaultPii: false,
    beforeSend(event) {
      // Strip phones / emails from URLs before they leave the browser
      try {
        if (event?.request?.url) {
          event.request.url = event.request.url.replace(/(\d{10})/g, "[phone]");
        }
      } catch { /* never block error reporting */ }
      return event;
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{padding:40,textAlign:"center",fontFamily:"sans-serif"}}>Something went wrong. The team has been notified — please refresh.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

registerServiceWorker();
